import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '@shared/environments';
import { GetMemberBySSNResponse } from '../../interfaces/member';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  private http = inject(HttpClient);

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };
  _appName: string = '';

  private apiUrl = `${environment.api}members/`;
  private api = `${environment.api}`;

  get appName() {
    return this._appName;
  }
  set appName(appname: string) {
    this._appName = appname;
  }
  getClientHistory(): Observable<any> {
    return of([
      {
        userId: 60,
        examDate: '2023-09-12',
        type: 'νοσηλεία',
        cost: 300,
        notes: 'Εισαγωγή λόγω τραυματισμού',
        status: 'ολοκληρώθηκε',
      },
      {
        userId: 60,
        examDate: '2023-10-25',
        type: 'εξετάσεις',
        cost: 120,
        notes: 'Αιματολογικές εξετάσεις',
        status: 'εκκρεμεί',
      },
      {
        userId: 60,
        examDate: '2024-01-10',
        type: 'νοσηλεία',
        cost: 800,
        notes: 'Χειρουργική επέμβαση',
        status: 'ολοκληρώθηκε',
      },
      {
        userId: 60,
        examDate: '2024-02-18',
        type: 'εξετάσεις',
        cost: 50,
        notes: 'Τακτικός έλεγχος',
        status: 'εκκρεμεί',
      },
      {
        userId: 60,
        examDate: '2023-11-05',
        type: 'νοσηλεία',
        cost: 1500,
        notes: 'Μακροχρόνια νοσηλεία',
        status: 'ολοκληρώθηκε',
      },
    ]);
  }

  getHistoryOfMedicines(): Observable<any> {
    return of([
      {
        date: '01/09/2024',
        medicineCode: 'P001',
        medicineName: 'Μετφορμίνη',
        generalName: 'Metformin Hydrochloride',
        brandName: 'Glucophage',
        administrationMethod: 'Δισκίο',
        dosage: '500mg',
      },
      {
        date: '15/09/2024',
        medicineCode: 'P002',
        medicineName: 'Σιταγλιπτίνη',
        generalName: 'Sitagliptin',
        brandName: 'Januvia',
        administrationMethod: 'Δισκίο',
        dosage: '100mg',
      },
      {
        date: '15/10/2024',
        medicineCode: 'P003',
        medicineName: 'Ινσουλίνη Γλαργίνη',
        generalName: 'Insulin Glargine',
        brandName: 'Lantus',
        administrationMethod: 'Ένεση',
        dosage: '100 units/mL',
      },
      {
        date: '25/10/2024',
        medicineCode: 'P004',
        medicineName: 'Αμοξυκιλλίνη / Κλαβουλανικό οξύ',
        generalName: 'Amoxicillin/Clavulanic Acid',
        brandName: 'Augmentin',
        administrationMethod: 'Δισκίο',
        dosage: '875mg / 125mg',
      },
      {
        date: '01/12/2024',
        medicineCode: 'P005',
        medicineName: 'Κεφαλεξίνη',
        generalName: 'Cephalexin',
        brandName: 'Keflex',
        administrationMethod: 'Κάψουλα',
        dosage: '500mg',
      },
      {
        date: '15/12/2024',
        medicineCode: 'P006',
        medicineName: 'Αμβροξόλη',
        generalName: 'Ambroxol',
        brandName: 'Mucosolvan',
        administrationMethod: 'Σιρόπι',
        dosage: '15mg/5mL',
      },
      {
        date: '01/02/2025',
        medicineCode: 'P007',
        medicineName: 'Σαλβουταμόλη',
        generalName: 'Salbutamol',
        brandName: 'Ventolin',
        administrationMethod: 'Εισπνοή',
        dosage: '100mcg/δόση',
      },
      {
        date: '15/02/2025',
        medicineCode: 'P008',
        medicineName: 'Ιβουπροφαίνη',
        generalName: 'Ibuprofen',
        brandName: 'Brufen',
        administrationMethod: 'Δισκίο',
        dosage: '400mg',
      },
      {
        date: '01/03/2025',
        medicineCode: 'P009',
        medicineName: 'Αμοξυκιλλίνη',
        generalName: 'Amoxicillin',
        brandName: 'Amoxil',
        administrationMethod: 'Δισκίο',
        dosage: '500mg',
      },
      {
        date: '15/03/2025',
        medicineCode: 'P010',
        medicineName: 'Ινσουλίνη Ντετεμίρη',
        generalName: 'Insulin Detemir',
        brandName: 'Levemir',
        administrationMethod: 'Ένεση',
        dosage: '100 units/mL',
      },
    ]);
  }

  getAllInsured(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`, this.httpOptions);
  }
  getMemberInfoByMemberId(memberId: string) {
    return this.http.get<any>(
      `${this.api}members/${memberId}`,
      this.httpOptions
    );
  }

  getAllClients(insuranceId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api}insurance/${insuranceId}/members`,
      this.httpOptions
    );
  }

  getClientDetails(insuredId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api}members/${insuredId}`,
      this.httpOptions
    );
  }

  getEntityByUsername(token: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    if (this.appName == 'insured') {
      return this.http.get<any>(`${this.api}aggregator/memberInfo`, {
        headers,
      });
    } else if (this.appName == 'insurers') {
      return this.http.get<any>(`${this.api}insurances/me`, {
        headers,
      });
    } else if (this.appName == 'doctor') {
      return this.http.get<any>(`${this.api}doctors/me`, {
        headers,
      });
    } else if (this.appName == 'medicalCenter') {
      return this.http.get<any>(`${this.api}medicalCenters/me`, {
        headers,
      });
    } else if (this.appName == 'hospital') {
      return this.http.get<any>(`${this.api}hospitals/me`, {
        headers,
      });
    } else if (this.appName == 'auditor') {
      return this.http.get<any>(`${this.api}auditors/me`, {
        headers,
      });
    } else {
      return of(null);
    }
  }

  getMemberByUsername(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}me`);
  }
  getMemberDetailsById(userId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${userId}`);
  }
  getMemberBySocialSecurityNumber(
    socialSecurityNumber: string
  ): Observable<GetMemberBySSNResponse> {
    return this.http.get<GetMemberBySSNResponse>(
      `${this.apiUrl}${socialSecurityNumber}`
    );
  }

  getInsurersByUserId(userId: string): Observable<any> {
    /* TODO */
    return this.http.get<any>(`${this.apiUrl}/${userId}/insurers`);
  }
  getContracts(): Observable<any> {
    return this.http.get<any>(`${this.api}policies`, this.httpOptions);
  }
  getCompensations(userId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api}members/${userId}/compensations`,
      this.httpOptions
    );
  }
  getClaimsInsideNetwork(userId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api}members/${userId}/claims-inside-network`,
      this.httpOptions
    );
  }
  getClaimsOutsideNetwork(userId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api}members/${userId}/claims-outside-network`,
      this.httpOptions
    );
  }

  getHistoryOfDiagnosis(userId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api}members/${userId}/history-of-diagnosis`,
      this.httpOptions
    );
  }
  getPatientStudyInstances(fullName: string = 'ZOURIDAKISANTONIOS'): Observable<any> {
    return this.http.get<any>(
      `${this.api}studyInstances?patientName=${fullName}`
    );
  }
}
